import {
  FETCH_HOME_CONTENT_SUCCESS,
  FETCH_HOME_CONTENT_FAILED,
  FETCH_NEWSAPI_NEWS_SUCCESS,
  FETCH_NEWSAPI_NEWS_FAILED
} from "../actions/actionTypes";

const initialState = {
  isLoading: true,
  content: {},
  error: false,
  news: []
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_HOME_CONTENT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        content: payload
      };
    case FETCH_HOME_CONTENT_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload
      };
    case FETCH_NEWSAPI_NEWS_SUCCESS:
      return {
        ...state,
        news: payload.articles
      };
    case FETCH_NEWSAPI_NEWS_FAILED:
      return {
        ...state,
        news: []
      };
    default:
      return state;
  }
}
